<template>
    <div>
        <top-navbar></top-navbar>
<div>
  

<div class=" mb-5 background_color">
  <h6 class="manage-boder pt-2 font1  decoration"><router-link class="decoration" to="/issuetracking/index"> {{language[1]['Home']}} </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> {{language[106]['Manage Category']}} </h6>
 
  <!-- <h6 class="custom-maintitle "><b>Issue Tracking</b></h6> -->

  <div class="container-fluid">
      <div style="border: 0px; padding: 0px; min-height:0px" class="navbar background_color">

        <div class="d-flex">
          <b-input-group size="sm" style="width: 225px;">
            <b-form-input id="filter-input" v-model="filter" type="search" placeholder="Search">
            </b-form-input>
            
    </b-input-group>
    <div style="margin-top: 11px;" class="ms-2" >
    <span class="custom-breadcrumb"><b>{{language[11]['Showing ']}} {{currentPage}}-{{currentPage*perPage}} {{language[12]['of ']}}  {{totalRows}} {{language[13]['items']}}.</b></span>
  </div>

        </div>
  


        <div class="d-grid gap-2 d-md-flex justify-content-md-end">

    

    <button  @click="categoryCreate()"  class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad font-size_def">   {{language[107]['Create Category']}}</button>


</div>
</div>



<div class="card bdr-rad2 mt-1 shadow p-2 ">
<div class="card-body ">
 

  <b-table responsive style="font-size: small;"   class="table-hover"
      :items="all_data"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
    
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
        head-variant="dark"
      
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
  
      show-empty
      small
     
    >
   

    <!-- @filtered="onFiltered" -->
     
      <template #cell(no)="row">
                   {{ row.index + 1 === 10 ? currentPage * 10 : (currentPage - 1)*10 + row.index + 1 }} 
                    </template>

      <template #cell(actions)="row">

        <div class="dropdown">
  <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad font-size_def" type="button" data-toggle="dropdown" aria-expanded="false">
    {{language[77]['Action']}}
  </button>
  <div class="dropdown-menu bdr-rad">
  
    <a class="dropdown-item mouse-cursor"@click="ViewPage(row.item.id)"   >{{language[28]['View']}}</a>
    <!-- <a class="dropdown-item mouse-cursor"@click="Update(row.item.id)"   >{{language[78]['Update']}}</a> -->
    <a v-show="row.item.statusvalue==1" class="dropdown-item mouse-cursor"@click="Inactive(row.item.id)"   >{{language[56]['Inactive']}}</a>
    <a v-show="row.item.statusvalue==2" class="dropdown-item mouse-cursor"@click="active(row.item.id)"   >{{language[55]['Active']}}</a>

   
  </div>
</div>
      
       
       
      </template>


      <template #cell(status)="row">
        <div style="background-color: green;text-align: center;border-radius: 12px;padding: 4px;" v-show="row.item.statusvalue==1" >{{ row.item.status }} </div>
        <div style="background-color: red;text-align: center;border-radius: 12px;padding: 4px;" v-show="row.item.statusvalue==2" >{{ row.item.status }} </div>

        </template>




      <template #row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
      </template>
    </b-table>
    
      <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-5">
        <b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" size="sm"></b-pagination>
      </b-col>

      

  
    
    

  
</div>
</div>
</div>
<br><br>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import httpClient from '@/axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        language:JSON.parse(authService.isLanguage()),
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 15,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
       
        all_data:[],
        fields:[],
        
      


        
      }

    },
    computed: {
     
    },
    created(){
     
      
  this.loadIssue();


    },
    mounted(){
     
      
      this.fields= [
          { key: 'no', label: '#', sortable: true, },
          { key: 'main_cat_name', label: this.language[16]['Main Category'], sortable: true,  },
          { key: 'sub_cat_name', label:this.language[17]['Sub Category'], sortable: true,  },
          { key: 'status', label: this.language[22]['Status'], sortable: true  },
        
         
          
          { key: 'actions', label: 'Actions',  }
        ];


    },
methods : {
 
  Update(id){
    this.$router.push('/setting/update?id='+id);
  },
  ViewPage(id){
    this.$router.push('/category/view?id='+id);
  },
  categoryCreate(){
    this.$router.push('/category/create');
  },

  loadIssue(id) {

this.filterOn = id;
  },

 
 




  async loadIssue() {
    console.log(this.access_token);
    try {
      const { data} = await  httpClient.get('/web/api/issuetracking/loadcategory',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
         this.all_data = data.all_data;
        this.totalRows =  this.all_data.length;
      
    } catch (error) {
      console.log(error.response);
    }
  },


  async Inactive(id) {
    console.log(this.access_token);
    try {
      const { data} = await  httpClient.get('/web/api/issuetracking/maininactive?id='+id,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
        if(data.status==200){
          this.loadIssue();
        }
      
    } catch (error) {
      console.log(error.response);
    }
  },
  async active(id) {
    console.log(this.access_token);
    try {
      const { data} = await  httpClient.get('/web/api/issuetracking/mainactive?id='+id,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
        if(data.status==200){
          this.loadIssue();
        }
      
    } catch (error) {
      console.log(error.response);
    }
  },
   

       


 
  


 


},

    components :{
        ContentFooter,
        TopNavbar
    },
  }

</script>
<style >

</style>